/*eslint-disable*/
import React from "react";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import { getMe } from "../../utils/store/actions/users.actions";
import { connect } from "react-redux";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Cookies from "js-cookie";
import LanguageMenu from "../LanguageMenu/LanguageMenu";

type Props = {
  brandText: string;
};

class AdminNavbar extends React.PureComponent<any> {
  constructor(props: any) {
    super(props);
  }
  componentDidMount() {
    this.props
      .getMe()
  }
  logout() {
    Cookies.remove("authToken");
    Cookies.remove("accessToken");
    Cookies.remove("logeed");
    window.location.reload();
  }
  render() {
    const { brandText } = this.props;
    return (
      <>
        <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
          <Container
            fluid
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Nav className="align-items-center d-none d-md-flex" navbar>
              <LanguageMenu />
              <UncontrolledDropdown nav>
                <DropdownToggle className="pr-0" nav>
                  <Media className="align-items-center">
                    <span
                      className="avatar avatar-sm rounded-circle"
                      style={{ backgroundColor: "#4b0084" }}
                    ></span>
                    <Media className="ml-2 d-none d-lg-block">
                      <span
                        className="mb-0 text-sm font-weight-bold"
                        style={{ color: "#4b0084" }}
                      >
                        {this.props.LocalUser.me.id !== ""
                          ? this.props.LocalUser.me.firstName
                          : "guest"}
                      </span>
                      <ArrowDropDownIcon style={{ color: "#4b0084" }} />
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow" right>
                  <DropdownItem divider />
                  <DropdownItem href="#pablo" onClick={this.logout}>
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }
}

const mapStateToProps = (state: { LocalUser: LocalUserState }) => ({
  LocalUser: state.LocalUser,
});

export default connect(mapStateToProps, { getMe })(AdminNavbar);
